var address = {};
module['exports'] = address;
address.city = require("./city");
address.city_prefix = require("./city_prefix");
address.default_country = require("./default_country");
address.postcode = require("./postcode");
address.state = require("./state");